import { render, staticRenderFns } from "./addStage.vue?vue&type=template&id=87beee8a"
import script from "./addStage.vue?vue&type=script&lang=js"
export * from "./addStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports